var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 13.5C0 10.1863 2.68629 7.5 6 7.5H42C45.3137 7.5 48 10.1863 48 13.5V34.5C48 37.8137 45.3137 40.5 42 40.5H6C2.68629 40.5 0 37.8137 0 34.5V13.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42 8.5H6C3.23858 8.5 1 10.7386 1 13.5V34.5C1 37.2614 3.23858 39.5 6 39.5H42C44.7614 39.5 47 37.2614 47 34.5V13.5C47 10.7386 44.7614 8.5 42 8.5ZM6 7.5C2.68629 7.5 0 10.1863 0 13.5V34.5C0 37.8137 2.68629 40.5 6 40.5H42C45.3137 40.5 48 37.8137 48 34.5V13.5C48 10.1863 45.3137 7.5 42 7.5H6Z",
    fill: "#E4E4E4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.62773 21.1298H6V26.8308H7.62773C8.48555 26.8308 9.11695 26.6234 9.65977 26.1698C10.3109 25.627 10.6955 24.8184 10.6955 23.9803C10.6849 22.3034 9.43266 21.1298 7.62773 21.1298ZM8.92922 25.4105C8.58398 25.7262 8.13047 25.864 7.41047 25.864H7.11445V22.0966H7.41047C8.13047 22.0966 8.5643 22.2246 8.92922 22.56C9.31383 22.9052 9.54094 23.4277 9.54094 23.9803C9.54094 24.5224 9.31383 25.0652 8.92922 25.4105Z",
    fill: "#231F20"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3122 21.1298H11.1978V26.8308H12.3122V21.1298Z",
    fill: "#231F20"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0248 23.3194C14.354 23.0726 14.167 22.9052 14.167 22.5994C14.167 22.2443 14.5122 21.968 14.9953 21.968C15.3306 21.968 15.5971 22.1058 15.8924 22.4313L16.4746 21.672C16.0014 21.2578 15.4291 21.0406 14.7977 21.0406C13.7915 21.0406 13.0223 21.7409 13.0223 22.6683C13.0223 23.4572 13.3774 23.8517 14.4229 24.2264C14.8567 24.3839 15.0838 24.4831 15.1921 24.552C15.4192 24.6996 15.5275 24.907 15.5275 25.144C15.5275 25.6074 15.1626 25.9427 14.6697 25.9427C14.1374 25.9427 13.7128 25.6763 13.4568 25.1834L12.7368 25.8738C13.2494 26.6234 13.8611 26.9588 14.7091 26.9588C15.8629 26.9588 16.6715 26.1895 16.6715 25.0849C16.6722 24.1877 16.2974 23.7827 15.0248 23.3194Z",
    fill: "#231F20"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0171 23.9803C17.0171 25.6573 18.3291 26.9489 20.0251 26.9489C20.4983 26.9489 20.9124 26.8505 21.4158 26.6135V25.3015C20.9722 25.7452 20.5777 25.9231 20.0743 25.9231C18.9598 25.9231 18.1611 25.1145 18.1611 23.9606C18.1611 22.8659 18.9795 22.0081 20.0251 22.0081C20.5573 22.0081 20.9525 22.1958 21.4158 22.6493V21.3373C20.9328 21.0905 20.5285 20.992 20.0447 20.992C18.3678 21.0019 17.0171 22.3231 17.0171 23.9803Z",
    fill: "#231F20"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2233 24.957L28.7046 21.1298H27.4917L29.9175 26.9784H30.5095L32.9754 21.1298H31.7723L30.2233 24.957Z",
    fill: "#231F20"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4785 26.8308H36.625V25.864H34.5831V24.3256H36.5463V23.3588H34.5831V22.0966H36.625V21.1298H33.4785V26.8308Z",
    fill: "#231F20"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0235 22.8166C41.0235 21.7514 40.2937 21.1298 39.0112 21.1298H37.3638V26.8308H38.4782V24.5428H38.6259L40.1643 26.8308H41.5354L39.7403 24.4338C40.5602 24.2566 41.0235 23.6843 41.0235 22.8166ZM38.7946 23.7532H38.4691V22.027H38.8143C39.5048 22.027 39.8796 22.3132 39.8796 22.875C39.8796 23.4473 39.5048 23.7532 38.7946 23.7532Z",
    fill: "#231F20"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8084 27.0277C26.4805 27.0277 27.8361 25.6721 27.8361 24C27.8361 22.3279 26.4805 20.9724 24.8084 20.9724C23.1363 20.9724 21.7808 22.3279 21.7808 24C21.7808 25.6721 23.1363 27.0277 24.8084 27.0277Z",
    fill: "url(#paint0_linear_129_6998)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M24.8084 27.0277C26.4805 27.0277 27.8361 25.6721 27.8361 24C27.8361 22.3279 26.4805 20.9724 24.8084 20.9724C23.1363 20.9724 21.7808 22.3279 21.7808 24C21.7808 25.6721 23.1363 27.0277 24.8084 27.0277Z",
    fill: "url(#paint1_linear_129_6998)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7339 21.3471C41.7339 21.2487 41.665 21.1896 41.5462 21.1896H41.3887V21.6923H41.5068V21.4948L41.6446 21.6923H41.7923L41.6249 21.4849C41.6945 21.4652 41.7339 21.416 41.7339 21.3471ZM41.5272 21.416H41.5075V21.288H41.5272C41.5863 21.288 41.6158 21.3077 41.6158 21.3569C41.6158 21.3963 41.5863 21.416 41.5272 21.416Z",
    fill: "#231F20"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5662 21.0019C41.3194 21.0019 41.1323 21.1995 41.1323 21.4357C41.1323 21.6825 41.3299 21.8695 41.5662 21.8695C41.8031 21.8695 42 21.672 42 21.4357C42 21.1995 41.8024 21.0019 41.5662 21.0019ZM41.5662 21.8006C41.3784 21.8006 41.2209 21.6431 41.2209 21.4456C41.2209 21.248 41.3784 21.0905 41.5662 21.0905C41.7539 21.0905 41.9114 21.2578 41.9114 21.4456C41.9114 21.6424 41.7532 21.8006 41.5662 21.8006Z",
    fill: "#231F20"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_129_6998",
    x1: 26.3603,
    y1: 26.4296,
    x2: 24.262,
    y2: 23.1443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F89F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2502,
    stopColor: "#F79A20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5331,
    stopColor: "#F68D20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6196,
    stopColor: "#F58720"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7232,
    stopColor: "#F48120"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F37521"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_129_6998",
    x1: 26.0287,
    y1: 26.3848,
    x2: 22.962,
    y2: 20.3907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F58720"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3587,
    stopColor: "#E16F27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703,
    stopColor: "#D4602C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9816,
    stopColor: "#D05B2E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscover);
export default __webpack_public_path__ + "static/media/Discover.5d0bdba91cf01f897fc160681efefcc9.svg";
export { ForwardRef as ReactComponent };